import { Scale, FileText, Gavel, BookOpen, Users, ShieldCheck } from "lucide-react";

interface EmptyStateProps {
  onSuggestionClick: (text: string) => void;
  isStreaming?: boolean;
}

const suggestions = [
  { 
    icon: Scale, 
    title: "Prescrição trabalhista",
    subtitle: "Prazos, contagem e exceções",
    text: "Como funciona a prescrição trabalhista?" 
  },
  { 
    icon: FileText, 
    title: "Usucapião",
    subtitle: "Requisitos e modalidades",
    text: "Quais são os requisitos para usucapião?" 
  },
  { 
    icon: Gavel, 
    title: "Dano moral vs material",
    subtitle: "Diferenças e aplicações",
    text: "Explique a diferença entre dano moral e material" 
  },
  { 
    icon: BookOpen, 
    title: "Abandono de emprego",
    subtitle: "Caracterização e consequências",
    text: "O que caracteriza abandono de emprego?" 
  },
  { 
    icon: Users, 
    title: "Direito do consumidor",
    subtitle: "Garantias e devoluções",
    text: "Quais são os direitos do consumidor em compras online?" 
  },
  { 
    icon: ShieldCheck, 
    title: "Habeas corpus",
    subtitle: "Quando e como impetrar",
    text: "Quando posso impetrar habeas corpus?" 
  },
];

const EmptyState = ({ onSuggestionClick, isStreaming = false }: EmptyStateProps) => {
  return (
    <div className="flex-1 flex flex-col items-center justify-center p-4 md:p-8 max-w-4xl mx-auto w-full">
      <div className="text-center mb-10">
        <h1 className="text-3xl md:text-4xl font-bold tracking-tight mb-2">
          Como posso ajudar?
        </h1>
        <p className="text-muted-foreground text-sm">
          Pergunte sobre qualquer tema jurídico brasileiro
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 w-full" data-tour="suggested-questions">
        {suggestions.map((suggestion, idx) => {
          const Icon = suggestion.icon;
          return (
            <button
              key={idx}
              onClick={() => !isStreaming && onSuggestionClick(suggestion.text)}
              disabled={isStreaming}
              className="flex items-start gap-3 p-4 rounded-xl border bg-card hover:bg-accent/50 transition-all text-left group disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <div className="w-8 h-8 rounded-lg bg-muted flex items-center justify-center shrink-0 group-hover:bg-primary/10 transition-colors">
                <Icon className="w-4 h-4 text-muted-foreground group-hover:text-primary transition-colors" />
              </div>
              <div className="min-w-0">
                <p className="text-sm font-medium truncate">{suggestion.title}</p>
                <p className="text-xs text-muted-foreground">{suggestion.subtitle}</p>
              </div>
            </button>
          );
        })}
      </div>

      <p className="text-xs text-muted-foreground/70 mt-8 max-w-md text-center">
        ⚠️ Informações gerais — não substitui a consulta com advogado
      </p>
    </div>
  );
};

export default EmptyState;
